import {ReverseGeocodingData} from "@containers/reverseGeocoding/types";

export const buildAddressReverseGeocoding = (res?: ReverseGeocodingData | null): string | undefined => {
    const address = res?.address
    if (!address?.road) {
        return res?.display_name
    }
    const settlement = address.city || address.town || address.village
    return [address.road, address.house_number, settlement]
        .filter(Boolean)
        .join(', ')
}
